// Config
import paymentTypeConstants from './paymentTypeConstants';
import supportedCreditCardTypes from './supportedCreditCardTypes';

// Assets
import amexLogo from '@assets/images/logos/lozenge/amex.svg';
import applePayLogo from '@assets/images/logos/lozenge/apple-pay.svg';
import buyNowPayLaterLogo from '@assets/images/logos/lozenge/buy-now-pay-later.svg';
import clearpayLogo from '@assets/images/logos/lozenge/clearpay.svg';
import googlePayLogo from '@assets/images/logos/lozenge/google-pay.svg';
import johnLewisMoneyLogo from '@assets/images/logos/lozenge/john-lewis-money.svg';
import klarnaLogo from '@assets/images/logos/lozenge/klarna.svg';
import mastercardLogo from '@assets/images/logos/lozenge/mastercard.svg';
import partnership2022Logo from '@assets/images/logos/lozenge/partnership-2022.svg';
import paypalLogo from '@assets/images/logos/lozenge/pay-pal.svg';
import prePaidCardLogo from '@assets/images/logos/lozenge/one4all.svg';
import visaLogo from '@assets/images/logos/lozenge/visa.svg';

const paymentLogoConstants: Record<string, string> = {
  [paymentTypeConstants.APPLE_PAY]: applePayLogo,
  [paymentTypeConstants.APPLE_PAY_EXPRESS]: applePayLogo,
  [paymentTypeConstants.CLEARPAY]: clearpayLogo,
  [paymentTypeConstants.GOOGLE_PAY]: googlePayLogo,
  [paymentTypeConstants.KLARNA]: klarnaLogo,
  [paymentTypeConstants.PAYPAL]: paypalLogo,
  [paymentTypeConstants.PAYPAL_EXPRESS]: paypalLogo,
  [paymentTypeConstants.PAYPAL_PAY_LATER]: paypalLogo,
  [paymentTypeConstants.POS_CREDIT]: johnLewisMoneyLogo,
  [paymentTypeConstants.PREPAID_CARD]: prePaidCardLogo,
  [supportedCreditCardTypes.AMERICAN_EXPRESS]: amexLogo,
  [supportedCreditCardTypes.MAESTRO]: mastercardLogo,
  [supportedCreditCardTypes.MASTERCARD]: mastercardLogo,
  [supportedCreditCardTypes.ANY_DAY]: mastercardLogo,
  [supportedCreditCardTypes.NEW_DAY]: partnership2022Logo,
  [supportedCreditCardTypes.VISA]: visaLogo,
  [supportedCreditCardTypes.VISA_DEBIT]: visaLogo,
  paymentHoliday: buyNowPayLaterLogo,
};

export default paymentLogoConstants;
